import {useNavigate} from 'react-router-dom'
import {DynamicColumnTable} from '@/components/organisms'
import {getCellDataMappedCols} from '@/helpers/dataTableCellDataMapper'
import {LinkText} from '@/components/atoms'
import {setItemDetail} from '@/store/slices/itemSlice'
import {useAppDispatch} from '@/store'
import './SubItemDataTable.scss'

// Define the product cell renderer outside of the SubItemDataTable component
const subItemCellDataMapperObj = (navigate, itemDetails, dispatch) => {
  return {
    product: ({row: {original} = {}}) => ( 
      <LinkText
        text={original?.product}
        id={original?.product + ' ' + original?.id}
        handleClick={() => {
          dispatch(setItemDetail(itemDetails))
          navigate(`/orders/item/${original?.product}`, {
            state: {itemDetails: itemDetails}, // Pass object with navigate
          })
        }}
      />
    ),
    orderPrice: ({row: {original} = {}}) => <div>{original?.orderPrice?.toFixed(2)}</div>,
    orderState: ({row: {original} = {}}) => <div>{original?.orderState || '-'}</div>,
  }
}

export const SubItemDataTable = ({subItemAccordionData, itemDetails}) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const {subItemList = [], subItemColConfigData = []} = subItemAccordionData || {}
  const cellDataMappedCols = getCellDataMappedCols(
    subItemCellDataMapperObj(navigate, itemDetails, dispatch),
    subItemColConfigData
  )

  return (
    <div>
      {subItemColConfigData?.length > 0 && subItemList?.length > 0 && (
        <DynamicColumnTable
          columns={cellDataMappedCols || []}
          records={subItemList || []}
          selection="none"
          showColumnFilters={false}
          allowAsPropOptions={true}
        />
      )}
    </div>
  )
}